import { createContext, useMemo, useState } from 'react';

export const FilterContext = createContext(null);

function FilterProvider({ children }) {
  const [filterSuggested, setFilterSuggested] = useState(true);
  const [filterLocation, setFilterLocation] = useState(false);
  const [filterFast, setFilterFast] = useState(false);

  const filterProviderValue = useMemo(
    () => ({
      filterSuggested,
      setFilterSuggested,
      filterLocation,
      setFilterLocation,
      filterFast,
      setFilterFast,
    }),
    [
      filterSuggested,
      setFilterSuggested,
      filterLocation,
      setFilterLocation,
      filterFast,
      setFilterFast,
    ],
  );

  return (
    <FilterContext.Provider value={filterProviderValue}>
      {children}
    </FilterContext.Provider>
  );
}

export default FilterProvider;
